import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { useOnboardingStore } from "@/store/onboardingStore";
import { ROUTES } from "@/constants/routes";
import type { JSX } from "react";

interface PrivateRouteProps {
  children: JSX.Element;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, loading } = useAuthStore();
  const location = useLocation();
  const hasPendingOnboarding = useOnboardingStore((state) => state.isOnboardingPending());

  // Show temporary loader only while checking auth
  if (loading) {
    return <div className="p-6 text-center">Checking authentication...</div>;
  }

  // Not logged in → redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated → allow access
  const onboardingAllowedPaths = [
    ROUTES.MAIN.DASHBOARD,
    ROUTES.MAIN.ONBOARDING_KYC,
    ROUTES.MAIN.ONBOARDING_SIGNATORY,
  ];

  if (hasPendingOnboarding && !onboardingAllowedPaths.includes(location.pathname as any)) {
    return <Navigate to={ROUTES.MAIN.DASHBOARD} replace />;
  }

  return children;
};
